// import './index.html';
// import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import dva from 'dva';
import createLoading from 'dva-loading';
import { browserHistory } from 'dva/router';
import { message } from 'antd';
import { LocaleProvider } from 'antd';
import { addLocaleData, IntlProvider } from 'react-intl';

import registerServiceWorker from './registerServiceWorker';
import './vi-VN';

const appLocale = window.appLocale;

addLocaleData(appLocale.data);

// 1. Initialize
const app = dva({
  ...createLoading({
    effects: true,
  }),
  history: browserHistory,
  onError (error) {
    // error with format: {errorCode: string, message: string || {code, field}}
    console.log('app error', error);
    let msg = '';
    let textId = '';
    if (error.message.code) {
      textId = error.message.code;
      if (error.message.field) textId += `.${error.message.field}`;
    } else {
      textId = error.message;
    }
    if (appLocale.messages && appLocale.messages[textId]) msg = appLocale.messages[textId];
    else msg = error.message.message || error.message;
    message.error(msg);
  },
});

// 2. Model
app.model(require('./models/app').default);

// 3. Router
app.router(require('./router').default);

// 4. Start
const App = app.start();

// 5. Render
ReactDOM.render(
  (<LocaleProvider locale={appLocale.antd}>
    <IntlProvider locale={appLocale.locale} messages={appLocale.messages}>
      <App />
    </IntlProvider>
   </LocaleProvider>),
  document.getElementById('root')
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js